import React from 'react';

export default function CardStackSkeleton() {
  return (
    <>
      <div className="calendar-view__all-card">
        <div className="date-card date-card--all date-card--skeleton skeleton" />
      </div>
      <div className="calendar-view__cards">
        {[0, 1, 2, 3, 4, 5, 6].map(idx => (
          <div key={idx} className="date-card date-card--skeleton skeleton" />
        ))}
      </div>
    </>
  );
}
